<div>
  <div class="flex justify-between items-center">
    <app-special-message-pop-up-header [message]="message" [isPreview]="true" [isShowHeader]="isShowHeader()" />
    <mot-button [icon]="iconName" iconClass="text-sm" (click)="onClick()" />
  </div>
  @if (!isLast) {
    <hr class="border-gray-500 border-t-1 w-full opacity-50 m-0 my-2" />
  }
</div>